<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <loading
        :active.sync="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>

    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Categoría argumentario</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:right" class="textoSubtitulo">Argument_01</p>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="mt-2"></div>

      <b-container fluid="">
        <b-row class="text-center mt-4">
          <b-col cols="1" md="3"></b-col>

          <b-col cols="9" md="6">
            <b-row class="contenedorTablaSinColor" v-if="$localStorageService.can('Busqueda_argument')" style="background:white">
              <b-col cols="10" lg="11" class="pr-0">
                <b-input-group class="pl-3">
                  <b-form-input
                      class="input-filter"
                      maxLength="15"
                      v-model="filtro.palabraClave"
                      type="search"
                      id="nombreBusq"
                      name="nombre"
                      responsive
                      placeholder="Búsqueda de título categoría"
                      @keydown.enter.native="obtenerCategoriaArgumentario">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="2" lg="1" class="pl-0">
                <b-button
                    class="mt-1 pb-1"
                    size="sm"
                    variant="info"
                    :disabled="loader"
                    responsive
                    @click="obtenerCategoriaArgumentario"
                >
                <span v-if="!loader"
                >
                  <em class="buscar_svg primary sm"></em>
                </span>
                  <span v-else><b-spinner small></b-spinner></span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="1" class="text-left mt-auto mb-auto">
            <b-button
                v-if="$localStorageService.can('Nuevo_argument')"
                variant="primary"
                v-b-tooltip.hover
                title="Alta de categoría argumentario"
                class="paddingbotones2 botonesAzulFuerte"
                @click="agregar"
                responsive
            ><em class="herramienta_svg sm"></em>
            </b-button>
          </b-col>

          <div class="col-12">
            <b-row>
              <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                <b-table
                    id="Pendientes"
                    thead-tr-class="columnasTablaSinColor"
                    :items="datosTabla"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    responsive="true"
                    fixed
                >
                  <template v-slot:cell(fechaModificacion)="row">
                    <div>
                      {{ row.item.fechaModificacion | formatoFechaCortaDMA }}
                    </div>
                  </template>
                  <template v-slot:cell(Acciones)="row" style="width: 200px">
                    <b-button size="sm" variant="warning" class=" mr-1 marginbotones "
                              style="border-radius:15px"
                              v-if="row.item.registroActivo && $localStorageService.can('Editar_argument')"
                              v-b-tooltip.hover
                              title="Editar"
                              @click="modificar(row.item)"
                    >
                      <em class="editar_svg sm"></em>
                    </b-button>
                    <b-button size="sm" variant="outline-success" class=" mr-1 marginbotones "
                              style="border-radius:15px"
                              v-if="!row.item.registroActivo && $localStorageService.can('Activar_argument')"
                              v-b-tooltip.hover
                              title="Activar categoría"
                              @click="activarDesactivar(row.item)">
                      <em class="fa fa-undo"></em>
                    </b-button>

                    <b-button size="sm" variant="danger" class="mr-1 marginbotones paddingbotones"
                              v-else-if="$localStorageService.can('Activar_argument')"
                              v-b-tooltip.hover
                              title="Desactivar categoría"
                              @click="activarDesactivar(row.item)">
                      <em class="eliminar_svg icon-boton"></em>
                    </b-button>
                  </template>
                </b-table>


                <div align="center" v-if="loader">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <b-col v-else>
                  <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
              </b-col>
              <b-col v-if="!loader">
                <b-pagination
                    v-if="datosTabla !== undefined && datosTabla.length > 10"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="datosTabla.length"
                    :per-page="registrosPorPagina"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>

        </b-row>
      </b-container>
    </b-card>

    <b-modal
        v-model="showModal"
        size="xl"
        class="redondeo"
        centered
        no-close-on-backdrop
        no-close-on-esc>
      <b-form @submit.stop.prevent="guardar">
        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="descripcion">Título
              </label>
              <validacion/>
              <b-input-group size="sm" class="mb-2">
                <b-form-input
                    class="redondeo"
                    id="titulo"
                    name="titulo"
                    placeholder="Título"
                    v-model="$v.objGuardar.titulo.$model"
                    :state="validateState('titulo')"
                    required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="descripcion">Descripción
              </label>
              <validacion/>
              <b-input-group size="sm" class="mb-2">
                <b-form-textarea
                    id="descripcion"
                    name="descripcion"
                    class="redondeo"
                    placeholder="Descripción"
                    v-model="$v.objGuardar.descripcion.$model"
                    :state="validateState('descripcion')"
                    required
                    rows="3"
                    max-rows="4"
                ></b-form-textarea>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="text-left">

            <div class="text-justify d-flex justify-content-between">
              <label for="descripcion">Imagen<validacion/>
              </label>

              <b-button v-if="objGuardar.imagenVista !== null" variant="danger" size="sm"
                        v-b-tooltip.hover.lefttop.v-light
                        title="Eliminar imagen" pill @click="quitarImg()">
                <b-icon icon="x" size="lg"></b-icon>
              </b-button>
            </div>
            <b-card style="height: 284px" class="text-center">
              <div v-if="objGuardar.imagenVista !== null">
                <img :src="'data:image/png;base64,' + objGuardar.imagenVista " alt="img" style="height: 240px"/>
              </div>
              <div v-else>
                <em class="subirImagen"></em>
                <b-form-file
                    ref="myFileInput"
                    v-model="$v.objGuardar.imagenVista.$model"
                    :state="validateState('imagenVista')"
                    placeholder="Arrastra la imagen aquí o "
                    drop-placeholder="Arrastra la imagen aquí o "
                    browse-text="Navega"
                    icon="download"
                    accept=".jpg, .png"
                    @change="base64"
                ></b-form-file>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>


      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">{{ tituloModal }}</div>
        </div>
      </template>

      <template #modal-footer="{ ok, cancel }">
        <div class="w-100 float-none text-center">
          <b-button class="mt-3 botonesAzulFuerte"
                    style="width:10%;margin:10px"
                    variant="primary"
                    :disabled="loaderAcciones"
                    @click="$refs.submitGuardar.click()"
          >
            Guardar
          </b-button>
          <b-button
              style="width:10%;margin:10px"
              class="mt-3 botonesGrisFuerte"
              :disabled="loaderAcciones"
              @click="cerrarModal()"
          >
            Cancelar
          </b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {maxLength, required} from "vuelidate/lib/validators";

export default {
  name: "CategoriaArgumentario",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      filtro: {
        palabraClave: null,
      },
      loader: false,
      loaderAcciones: false,
      tituloModal: '',
      showModal: false,
      datosTabla: [],
      fields: [
        {key: "idCategoria", label: "ID", sortable: true},
        {key: "titulo", label: "Título", sortable: true},
        {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
        {key: "usuarioModificacion", label: "Usuario modificación", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 1,
      objGuardar: {
        idCategoria: null,
        titulo: null,
        descripcion: null,
        urlImagen: null,
        imagenVista: null,
        cambioImg: false,
        extencionImagen: null
      }
    }
  },
  validations: {
    objGuardar: {
      titulo: {required, maxLength: maxLength(100)},
      descripcion: {required, maxLength: maxLength(500)},
      imagenVista: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCategoriaArgumentario();
  },
  methods: {
    obtenerCategoriaArgumentario() {
      this.loader = true;
      this.$http
          .post(this.$api + 'catalogo/categoriaArgumentario/obtener', this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    agregar() {
      this.tituloModal = 'Crear categoría';
      this.showModal = true;
    },
    cerrarModal() {
      this.showModal = false;
      this.limpiar()
    },
    modificar(item) {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.objGuardar = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar categoría';
      this.showModal = true;
    },
    activarDesactivar(item) {
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la categoría?' : '¿Está seguro de activar la categoría?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.loader = true;
          this.$http.post(this.$api + 'catalogo/categoriaArgumentario/desactivarActivar', item.idCategoria).then(respuesta => {
                if (respuesta.data.data) {
                  this.loader = false;
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La categoría se actualizó correctamente",
                  });
                }
              }
          ).catch(error => {
            console.error(error.message);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.message,
            });
          }).finally(() => {
            this.loader = false
          })
        }
      })
    },
    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }

      this.loader = true;
      this.loaderAcciones = true;
      this.$http.post(this.$api + 'catalogo/categoriaArgumentario/guardar', this.objGuardar).then(respuesta => {
            if (respuesta.data.data) {
              this.filtro.palabraClave = this.objGuardar.titulo;
              this.showModal = false;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "La categoría se guardó correctamente"
              });
              this.obtenerCategoriaArgumentario();
              this.limpiar();
            }
          }
      ).catch(error => {
        console.error(error.message)
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: error.message,
        });
      }).finally(() => {
        this.loader = false;
        this.loaderAcciones = false;
      })
    },
    base64(e){
      this.objGuardar.cambioImg = true;
      let base = e.target.files || e.dataTransfer.files;
      let extencion = base[0].type;
      if (extencion !== 'image/png' && extencion !== 'image/jpeg' && extencion !== 'image/jpg'){
        this.objGuardar.imagenVista = null;
        this.$refs.myFileInput.reset();
      } else {
        const file = new Blob([base[0]], { type: "image/png" });
        this.objGuardar.extencionImagen = file.type;
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (e) => {
          let imagen = e.target.result
          let indice = imagen.indexOf(",");
          let base64 = imagen.substring(indice+1, 100000000);
          this.objGuardar.imagenVista = base64
        };
      }
    },
    quitarImg(){
      this.objGuardar.imagenVista = null;
      this.objGuardar.cambioImg = true;
    },
    limpiar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.objGuardar = {
        idCategoria: null,
        titulo: null,
        descripcion: null,
        urlImagen: null,
        imagenVista: null
      }
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
</style>